<template>
  <modal :visible="visible" @on-close="close">
    <div :class="['modal-confirm', { 'modal-confirm-rich': !!showIcon}]">
      <div class="modal-confirm-icon" v-if="showIcon">
        <f-sprite-icon :icon-link="icon" />
      </div>
      <div class="modal-confirm-title" v-if="title" v-html="title" />
      <div class="modal-confirm-subtitle" v-if="subtitle" v-html="subtitle" />
      <div class="modal-confirm-buttons" v-if="buttons.length">
        <ui-button
          v-for="(b, i) in buttons"
          :key="i"
          :text="b.text"
          :flat="!!b.flat"
          :secondary="!!b.secondary"
          @click="buttonClick(b.action)"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import IconInfo from '../../../assets/images/info.multi.svg'
export default {
  name: 'Modal-confirm',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: IconInfo.id,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array,
      default: () => ([]),
    },
  },

  methods: {
    buttonClick(cb) {
      if (typeof cb === 'function') {
        cb();
      }
      this.close();
    },
    close() {
      this.$emit('on-close');
    },
  },

};
</script>

<style lang="scss">
.modal-confirm {
  &-icon {
    width: 64px;
    height: 64px;
    margin: 16px auto;
  }
  &-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  &-subtitle {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
  }
  &-buttons {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    width: 100%;
    > *:not(:first-child) {
      margin-top: 12px;
    }
  }
  &-rich {
    text-align: center;
  }
}

@include breakpoint("tablet") {
  .modal-confirm {
    min-width: 200px;
    max-width: 440px;
    &-buttons {
      flex-direction: row;
      > *:not(:first-child) {
        margin: 0 0 0 12px;
      }
    }
    &-rich {
      .buttons {
        justify-content: center;
      }
    }
  }
}
</style>
